import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createBlock(_component_a_select, {
    value: _ctx.selectedTags,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTags) = $event)),
    mode: "multiple",
    style: {"width":"100%"},
    labelInValue: "",
    placeholder: "可使用空格创建新标签",
    "filter-option": false,
    defaultActiveFirstOption: false,
    onSearch: _ctx.handleSearch,
    onInputKeyDown: _ctx.handleInput,
    onDeselect: _ctx.handleDeselect,
    onSelect: _ctx.handleSelect
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (op) => {
        return (_openBlock(), _createBlock(_component_a_select_option, {
          label: op.name,
          value: op.id
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(op.name), 1)
          ]),
          _: 2
        }, 1032, ["label", "value"]))
      }), 256))
    ]),
    _: 1
  }, 8, ["value", "onSearch", "onInputKeyDown", "onDeselect", "onSelect"]))
}